import { useLazyQuery } from "@apollo/client";

import useUrlParams from "./useUrlParams";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../context/context";
import {
  GetSwConfigVariablesResult,
  GetSwConfigVariablesVar,
  SwConfigQueryType,
} from "../components/modules/asset/masters/items/configurations/queries/type";
import { GetSwConfigVariables } from "../components/modules/asset/masters/items/configurations/queries/queries";
import { CustomerConfigurationTypes } from "../queries/types";

const useCompanyConfiguration = () => {
  const { customer_id } = useUrlParams();
  const { state } = useContext(AppContext);

  const [subsidiary, setSubsidiary] = useState(false);
  const [subsidiarySite, setSubsidiarySite] = useState(false);
  const [junction, setJunction] = useState(false);
  const [map, setMap] = useState(false);

  const [getSwConfigVariables, { data, loading }] = useLazyQuery<
    GetSwConfigVariablesResult,
    GetSwConfigVariablesVar
  >(GetSwConfigVariables);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (customer_id || state.customerId) {
          getSwConfigVariables({
            variables: {
              customerID: customer_id ? customer_id : state.customerId,
              input: {
                queryType: SwConfigQueryType.BY_CONFIG_KEY,
                strValue: [
                  CustomerConfigurationTypes.ENABLE_SUBSIDIARY,
                  CustomerConfigurationTypes.ENABLE_SUBSIDIARY_SITE,
                  CustomerConfigurationTypes.ENABLE_JUNCTION,
                  CustomerConfigurationTypes.ENABLE_MAPS,
                ],
                intValue: 1,
              },
            },
          });
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, [getSwConfigVariables, state.customerId, customer_id]);

  useEffect(() => {
    if (!loading && data) {
      // eslint-disable-next-line
      data.GetSwConfigVariables.forEach((config) => {
        const { configKey, booleanValue } = config;

        switch (configKey) {
          case CustomerConfigurationTypes.ENABLE_SUBSIDIARY:
            setSubsidiary(booleanValue);
            break;

          case CustomerConfigurationTypes.ENABLE_SUBSIDIARY_SITE:
            setSubsidiarySite(booleanValue);
            break;

          case CustomerConfigurationTypes.ENABLE_JUNCTION:
            setJunction(booleanValue);
            break;

          case CustomerConfigurationTypes.ENABLE_MAPS:
            setMap(booleanValue);
            break;

          default:
            break;
        }
      });
    }
  }, [loading, data, customer_id]);

  return {
    USE_ENABLE_SUBSIDIARY: subsidiary,
    USE_ENABLE_SUBSIDIARY_SITE: subsidiarySite,
    USE_ENABLE_JUNCTION: junction,
    USE_ENABLE_MAP: map,
  };
};

export default useCompanyConfiguration;
